/**
 * SGKC008A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface TankatableregistrationInfo {

    /**
     * 単価表コード
     */
    tankatableCode?: string;
    /**
     * 単価表コード履歴番号
     */
    tankahyocodeRrkno?: string;
}

